import ReactMarkdown from "react-markdown";
import rehypeSanitize from "rehype-sanitize";
import { cn } from "@/lib/utils";

type MarkdownBodyProps = {
  content: string;
  className?: string;
};

export function MarkdownBody({ content, className }: MarkdownBodyProps) {
  return (
    <div
      className={cn(
        "prose prose-sm max-w-none text-[var(--site-muted)]",
        "prose-headings:font-display prose-headings:text-[var(--site-primary)]",
        "prose-a:text-[var(--site-accent)] prose-strong:text-[var(--site-text)]",
        "prose-p:leading-relaxed prose-li:leading-relaxed",
        className
      )}
    >
      <ReactMarkdown rehypePlugins={[rehypeSanitize]}>{content}</ReactMarkdown>
    </div>
  );
}
